<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData } from '../../types/flow-types';
	import { Icon } from '@Shelly/shelly-design-system';
	import { resolveWeatherConditionSummary } from '../../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	const iconMap: Record<string, string> = {
		temperature: 'fa-thermometer-half',
		humidity: 'fa-droplet',
		clouds: 'fa-cloud',
		wind_speed: 'fa-wind',
		wind_force: 'fa-wind',
		wind_direction: 'fa-compass',
		chance_precipitation: 'fa-cloud-rain',
	};

	$: weatherCond = (data.weatherCond as string) || (data.cond as string) || 'temperature';
	$: icon = iconMap[weatherCond] || 'fa-cloud-sun';
	$: displayText = resolveWeatherConditionSummary(data);
</script>

<BaseConditionNode
	{id}
	type="weatherCondition"
	{data}
	{selected}
	{validated}
	{errors}
	{...$$restProps}
	cardTitle={displayText}
	nodeTypeLabel="Weather"
>
	<div class="body">
		<i class="fa {icon} weather-icon" />
		<div class="description">{displayText}</div>
		<span class="premium-indicator" title="Premium" aria-label="Premium">
			<Icon size="s" icon="fas fa-gem icon-premium-color" />
		</span>
	</div>
</BaseConditionNode>

<style>
	.body {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		padding: 0.5rem;
		position: relative;
	}

	.weather-icon {
		color: #6366f1;
		font-size: 1rem;
		flex-shrink: 0;
	}

	.description {
		color: var(--flow-slot-strong, #fff);
		font-size: 0.875rem;
		line-height: 1.4;
		flex: 1;
	}

	.premium-indicator {
		display: flex;
		align-items: center;
		flex-shrink: 0;
	}
</style>
